import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import {
  getMemberProgress,
  checkIn,
  getVipLevelRequirementAndReward,
  clearProgress,
  simulateCheckIn
} from "../../store/ducks/dailyCheckIn/actions";
import Swal from "sweetalert2";
import CheckInStepProgress from "../../components/CheckInStepProgress/CheckInStepProgress";
import { isDesktop } from "react-device-detect";
import popGif from "../../assets/images/check-in/pop.gif";

class MemberProgress extends Component {  

  selectedDay = 0;

  constructor(props) {
    super(props);

    // Initial values with identical data structure to the responses from GET daily_check_in/member_progress
    this.state = {
      isAuthenticated: false,
      timeLeft: { hours: 0, minutes: 0, seconds: 0 },
      showSimulator: false,
      simulator: {
        operation: 'check-in',
        checkInDate: new Date().toISOString().split("T")[0],
        usedCredit: 0,
        day: 0,
      }
    };
  }

  componentDidMount() {
    this.nextRewardsTimer();

    this.timer = setInterval(this.nextRewardsTimer, 1000);

    // If member is unauthenticated, still show the Daily Check-In popup but don't check for member progress
    this.setState(
      {
        ...this.state,
        isAuthenticated: localStorage.getItem("accessToken") || false,
      },
      () => {
        if (this.state.isAuthenticated) {
          this.props.getMemberProgress();
        }
      }
    );

    // Handle initial load if country_id is already set
    if (this.props.currentUser?.data?.country_id) {
      this.props.getVipLevelRequirementAndReward({
        country_id: this.props.currentUser.data.country_id
      });
    }
    
    const { t } = this.props;
    const { day } = this.props.memberProgress;
    // Previous Day Check In Status
    const { canCheckIn } = this.props.memberProgress?.days?.[day > 0 ? day - 1 : 0] || {};
    const ytdCanCheckIn = canCheckIn;
    const lastSeenDate = localStorage.getItem("vipPopupDate");
    const today = new Date().toISOString().split("T")[0];
    const img = this.imageImport(require.context("../../assets/images/check-in", false, /\.(png|jpe?g|svg|webp)$/));

    // 18/9/2025 !== 19/9/2025
    if(lastSeenDate !== today){
      // Only show on /check-in
      if(this.props.isCheckInPage && !ytdCanCheckIn){
        Swal.fire({
          iconHtml: `<img class="deposit" src="${img['missed-checkIn.webp']}" />`,
          icon: "info",
          html: `
            <p>${t("check_in.missed-check-in")}</p>
            <span>${t('check_in.please-deposit-3')}</span>
          `,
          confirmButtonText: t("check_in.deposit-now"),
          showCancelButton: (!isDesktop) ? false : '',
          customClass: {
            container: (isDesktop) ? "swal-check-in-container" : "swal-mobile-container swal-check-in-container",
          },
        }).then((result) => {
          if(result.isConfirmed){
            // navigate user to deposit
            window.location.replace("/deposit")
          }
        });
      }

      localStorage.setItem("vipPopupDate", today);
    }
  }

  componentDidUpdate(prevProps) {

    // country_id wasn't set on initial load or changes later
    if (
      prevProps.currentUser?.data?.country_id !== this.props.currentUser?.data?.country_id && 
      this.props.currentUser?.data?.country_id
    ) {
      this.props.getVipLevelRequirementAndReward({
        country_id: this.props.currentUser.data.country_id
      });
    }

    // Successfully checked-in response
    if (
      prevProps.resultCheckIn !== this.props.resultCheckIn &&
      this.props.resultCheckIn &&
      this.props.resultCheckIn.responseCode === 201 && 
      this.props.resultCheckIn.data
    ) {

      const { checkedInDay, offsetDayOfWeek } = this.props.resultCheckIn.data;

      const { days } = this.props.memberProgress;
      
      const { t } = this.props;

      const {
        rewardCredit: credit,
        rewardCoin: coin,
        rewardTotalFreeSpin: totalFreeSpin,
        extraRewardCredit: extraCredit,
        extraRewardCoin: extraCoin,
        extraRewardTotalFreeSpin: extraTotalFreeSpin
      } = days[checkedInDay];

      // Wraps nextDay between 0 and 6
      // If day + 1 = 6, nextDay will be 0
      const nextDay = (checkedInDay + 1) % days.length;
      const {
        rewardCredit: nextDayCredit,
        rewardCoin: nextDayCoin,
        rewardTotalFreeSpin: nextDayFreeSpin,
        extraRewardCredit: nextDayExtraCredit,
        extraRewardCoin: nextDayExtraCoin,
        extraRewardTotalFreeSpin: nextDayExtraTotalFreeSpin
      } = days[nextDay];

      const isShowCash = credit > 0 && credit < 250;
      const isShowMoreCash = credit >= 250;
      const isShowCoin = coin > 0 && coin < 150;
      const isShowMoreCoin = coin >= 150;
      const isShowFreeSpin = totalFreeSpin > 0 && totalFreeSpin < 3;
      const isShowMoreFreeSpin = totalFreeSpin >= 3;

      const img = this.imageImport(require.context("../../assets/images/check-in", false, /\.(png|jpe?g|svg|webp)$/));

      let comeBackNextDayMessage = `<span>${t('check_in.come-back-tomorrow')} ${nextDayCredit ? `MYR${nextDayCredit+nextDayExtraCredit}!` : nextDayCoin ? `${nextDayCoin+nextDayExtraCoin} ${t('check_in.coins')}!` : `x${nextDayFreeSpin+nextDayExtraTotalFreeSpin} ${t('check_in.free-spins')}!`}</span>`

      // Do not show come back next day message if the checked in day is in the past
      if (checkedInDay < offsetDayOfWeek) {
        comeBackNextDayMessage = '';
      }

      Swal.fire({
        iconHtml: 
          isShowCash ? `<img src="${img['cash.webp']}" />`
        : isShowMoreCash ? `<img src="${img['more-cash.webp']}"/>`
        : isShowCoin ? `<img src="${img['coin.webp']}"/>`            
        : isShowMoreCoin ? `<img class="more-coin" src="${img['more-coin.webp']}"/>`           
        : isShowFreeSpin ? `<img class="spin" src="${img['spin.webp']}"/>`            
        : isShowMoreFreeSpin ? `<img class="more-spin" src="${img['more-spin.webp']}"/>`            
        : "",
        title: t("lucky-spin.congratulation"),
        html: `
          <img class="pop-gif" src="${popGif}" alt="pop"/>
          <p>${t('check_in.you-have-got')} ${credit ? `MYR ${credit+extraCredit}!` : coin ? `${coin+extraCoin} ${t('check_in.coins')}!` : `x${totalFreeSpin+extraTotalFreeSpin} ${t('check_in.free-spins')}!`}</p>
          ${comeBackNextDayMessage}
        `,
        confirmButtonText: t("global.ok"),
        showCancelButton: false,
        customClass: {
          container: (isDesktop) ? "swal-check-in-container" : "swal-mobile-container swal-check-in-container",
        }
      }).then((result) => {
        if(result.isConfirmed){
          // if(isReCheckInAction){
          //   this.setState({ isReCheckInAction: false });
          // }
        }
      })

      // GET member progress and refresh state
      this.props.getMemberProgress();
    }

  }

  /**
   * operation: 'check-in' or 'recheck-in'
   */
  handleCheckIn = (operation) => {

    const { t } = this.props;
    const img = this.imageImport(require.context("../../assets/images/check-in", false, /\.(png|jpe?g|svg|webp)$/));

    if (!this.state.isAuthenticated) {

      // Unauthenticated. Redirect to login
      Swal.fire({
        iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : '',
        icon: "info",
        title: t("global.sorry"),
        text: t("global.login-proceed"),
        confirmButtonText: t("global.ok"),
        showCancelButton: (!isDesktop) ? false : '',
        customClass: (!isDesktop) ? {
          container: "swal-mobile-container sorry",
          icon: "swal-sorry-icon",
        } : []
      }).then((result) => {
        // user click ok button will redirect them to login
        if(result.isConfirmed){
          // store redirect url
          localStorage.setItem("redirectAfterLogin", "/check-in");
          // navigate user to login
          window.location.replace("/login")
        }
      });

      return;
    }

    const firstUncheckedInDay = this.props.memberProgress?.firstUncheckedInDay || 0;
    this.selectedDay = firstUncheckedInDay;
    const days = this.props.memberProgress?.days || [];

    const {
      canCheckIn,
      canRecheckIn,
      isCheckedIn,
      requiredCreditBalance
    } = days[firstUncheckedInDay];

    // Member meets all check-in requirements
    // Response is handled in componentDidUpdate()
    if(canCheckIn || canRecheckIn) {
      Swal.fire({
        title: t("message.loading"),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.props.checkIn({ operation });
    } else {

      let isShowPopupInsufficientDeposit = false;

      if (!isCheckedIn && requiredCreditBalance > 0) {
        isShowPopupInsufficientDeposit = true;
      }

      if (isShowPopupInsufficientDeposit) {
        Swal.fire({
          iconHtml: `<img class="deposit" src="${img['need-deposit.webp']}" />`,
          icon: "info",
          html: `
            <p>${t("check_in.not-enough-deposit")}</p>
            <span>${t('check_in.please-deposit-1')} <small>MYR ${requiredCreditBalance}</small> ${t('check_in.please-deposit-2')}</span>
          `,
          confirmButtonText: t("check_in.deposit-now"),
          showCancelButton: (!isDesktop) ? false : '',
          customClass: {
            container: (isDesktop) ? "swal-check-in-container" : "swal-mobile-container swal-check-in-container",
          },
        }).then((result) => {
          if(result.isConfirmed){
            // Navigate user to route /deposit
            window.location.replace("/deposit")
          }
        });
      }
    };
  }

  handleSimulateCheckIn = () => {
    this.props.simulateCheckIn({
      operation: this.state.simulator.operation,
      checkInDate: this.state.simulator.checkInDate,
      usedCredit: this.state.simulator.usedCredit,
      day: this.state.simulator.day,
    });
  }

  componentWillUnmount(){
    clearInterval(this.timer);
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  nextRewardsTimer = () => {
    const now = new Date();
    const nextDay = new Date();
    nextDay.setDate(now.getDate() + 1);
    nextDay.setHours(0, 0, 0, 0);

    const diff = nextDay - now;

    if (diff <= 0) {
      diff = 24 * 60 * 60 * 1000; // 24 hours
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.setState({
      timeLeft: { hours, minutes, seconds }
    })
  }

  formatTimer = (time) => {
    return String(time).padStart(2, "0");
  }

  /** 
   * Uses browser clock to get the offsetted day of the week.
   * 
   * Returns 0-6 (Monday - Sunday)
   */
  getCustomDayIndex = () => {
    const today = new Date();
    let day = today.getDay(); // 0 (Sun) - 6 (Sat)

    // Shift to Monday = 0, Sunday = 6
    return (day + 6) % 7;
  };

  getDayLabel = (day) => {
    const { t } = this.props;
    return t(`check_in.day-${day + 1}`);
  }

  /** day is zero-indexed */
  handleDayColumnClicked = (day, isShowFadedBackground) => {
    
  }

  render() {
    const { t } = this.props;
    
    const img = this.imageImport(require.context("../../assets/images/check-in", false, /\.(png|jpe?g|svg|webp)$/));
    const icon = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg|webp)$/));

    // Determine what rewards to show
    let rewards = [];

    const isMatchVip = this.props.currentSelectVip === this.props.memberProgress.vipLevel;

    // 0=Monday, 6=Sunday
    let day = 0;

    if (this.state.isAuthenticated) {
      day = this.props.memberProgress?.day || 0;
    } else {
      day = this.getCustomDayIndex();
    }

    if (this.state.isAuthenticated) {
      if (!this.props.isCheckInPage) {
        // Member is authenticated, not in route /check-in
        rewards = this.props.memberProgress?.days || [];
      } else if (this.props.isCheckInPage && isMatchVip) {
        // Member is authenticated, in route /check-in and have selected his own VIP Level
        rewards = this.props.memberProgress?.days || [];
      } else if (this.props.isCheckInPage && !isMatchVip) {
        // Member is authenticated, in route /check-in and have selected a different VIP Level
        const vipLevel = this.props.currentSelectVip ? this.props.currentSelectVip - 1 : 0;
        rewards = this.props.vipLevelRequirementAndReward.data?.vip_levels[vipLevel].days || [];
      }
    } else {
      // Member is not authenticated
      // Impossible to be in route /check-in
      // Must be in home page
      const vipLevel = this.props.memberProgress?.vipLevel || 0;
      rewards = this.props.vipLevelRequirementAndReward.data?.vip_levels[vipLevel].days || [];
    }

    let isEnableCheckInButton = false;
    let isEnableReCheckInButton = false;

    if (this.props.memberProgress?.firstUncheckedInDay > -1) {
      isEnableCheckInButton = this.props.memberProgress?.totalRemainingCheckIn > 0;

      if (this.props.memberProgress?.totalRemainingCheckIn === 0 && 
        this.props.memberProgress?.totalRemainingReCheckIn > 0 &&
        this.props.memberProgress?.firstUncheckedInDay <= day
      ) {
        isEnableReCheckInButton = true;
      }
    }

    if (!this.state.isAuthenticated) {
      isEnableCheckInButton = true;
      isEnableReCheckInButton = true;
    }
    
    return (
      <div className="d-flex flex-column gap-4">                        
        {/* Step Progress */}
        <div className={`check-in-progress ${this.props.isCheckInPage && isMatchVip && "show"}`}>
          <span style={{ color: "#C5C7C7", fontWeight: "500"}}>{t('check_in.check-in-progress')}</span>
          <CheckInStepProgress 
            key={this.props.currentSelectVip}
            memberProgress={this.props.memberProgress} 
            getDayLabel={this.getDayLabel}
            icon={icon}
            today={day}
            currentSelectVip={this.props.currentSelectVip}
          />
        </div>    

        <div className={`daily-check-in ${this.props.isCheckInPage && "isCheckIn"}`}>        
          <div className='check-in-container'>            
            <div className='row g-2'>
              {                                
                rewards.map((item, index, arr) => {
                  
                  const {
                    // Destructured from GetMemberProgress
                    canCheckIn,
                    canRecheckIn,
                    totalRemainingCheckIn,
                    totalRemainingReCheckIn,
                    isCheckedIn,
                    rewardCredit,
                    rewardCoin,
                    rewardTotalFreeSpin,
                    extraRewardCredit,
                    extraRewardCoin,
                    extraRewardTotalFreeSpin,

                    // Destructured from GetVipLevelRequirementAndReward
                    reward_credit,
                    reward_coin,
                    reward_total_free_spin,
                    extra_reward_coin,
                    extra_reward_credit,
                    extra_reward_total_free_spin,
                  } = item;

                  const creditValue = rewardCredit ?? reward_credit; 
                  const coinValue = rewardCoin ?? reward_coin;
                  const spinValue = rewardTotalFreeSpin ?? reward_total_free_spin;

                  const extraCreditValue = extraRewardCredit ?? extra_reward_credit;
                  const extraCoinValue = extraRewardCoin ?? extra_reward_coin;
                  const extraSpinValue = extraRewardTotalFreeSpin ?? extra_reward_total_free_spin;

                  const isShowCash = creditValue > 0 && creditValue < 250;
                  const isShowMoreCash = creditValue >= 250;
                  const isShowCoin = coinValue > 0 && coinValue < 150;
                  const isShowMoreCoin = coinValue >= 150;
                  const isShowFreeSpin = spinValue > 0 && spinValue < 3;
                  const isShowMoreFreeSpin = spinValue >= 3;

                  // CSS styling for each day
                  let isShowFadedBackground = true;
                  let isShowToday = false;
                  let isShowGradientBorder = false;
                  let isShowGoldBackground = false;
                  let isShowLastDay = false;
                  let isShowReCheckInAvailableTag = false;
                  let showTickOrCross = '';

                  if (this.props.memberProgress?.firstUncheckedInDay === index && !isCheckedIn) {
                    isShowFadedBackground = false;
                  }

                  if (!isCheckedIn && 
                    this.props.memberProgress?.firstUncheckedInDay === index &&
                    this.props.memberProgress?.totalRemainingCheckIn === 0 &&
                    this.props.memberProgress?.totalRemainingReCheckIn > 0) {
                      isShowReCheckInAvailableTag = true;
                  }

                  if (isCheckedIn) {
                    showTickOrCross = 'TICK';
                  }

                  if (index === arr.length - 4) { // Day 4
                    isShowGoldBackground = true;
                  }

                  if (index === arr.length - 1) {
                    isShowLastDay = true;
                  }

                  if (index < day && !isCheckedIn) {
                    showTickOrCross = 'CROSS';
                  }
                  
                  if (!this.state.isAuthenticated) {
                    isShowFadedBackground = false;
                  }

                  return (
                    <div 
                      key={index} 
                      className={index === arr.length - 1 ? 'col-6' : 'col-3'} 
                      onClick={() => {

                        if (this.props.memberProgress?.firstUncheckedInDay === index) {
                          if (isEnableCheckInButton) {
                            this.handleCheckIn('check-in')
                          } else if (isEnableReCheckInButton) {
                            this.handleCheckIn('recheck-in')
                          }
                        }
                        
                      }}>
                      {/* 
                        opacity: Reduced background transparency
                        current: today | Frame with header "Today"
                        gradient-border: An additional outer white frame
                        halfweek: Day 4 | 2nd row
                        lastDay: Last day | 2nd row, consume 2 columns
                      */}
                      <div className={`
                        position-relative check-in-col 
                        ${isShowFadedBackground && 'opacity'}                        
                        ${isShowToday && 'current'}
                        ${isShowGradientBorder && 'gradient-border'}
                        ${isShowGoldBackground && 'halfweek'}
                        ${isShowLastDay && 'lastDay'}`}
                      >
                        <div>
                          <h5>{this.getDayLabel(index)}</h5>
                          <div className={`${index === arr.length - 1 && "lastDay-container"}`}>
                            {index === 0 ? (
                              <img className="cash cny-reward cny-wallet" src={img['cny-wallet.webp']} alt="CNY wallet" />
                            ): index === 3 ? (
                              <img className="cash cny-reward cny-box" src={img['cny-box.webp']} alt="CNY box" />
                            ): index === 5 ? (
                              <img className="cash cny-reward cny-bag" src={img['cny-bag.webp']} alt="CNY bag" />
                            ): index === 6 ? (
                              <img className="cash cny-reward cny-cart" src={img['cny-cart.webp']} alt="CNY cart" />
                            ): isShowCash ? (
                              extraCreditValue > 0 ?                               
                              <img src={img['more-cash.webp']} alt="more cash" />    
                              :
                              <img className="cash" src={img['cash.webp']} alt="cash" />
                            ): isShowMoreCash ? (
                              <img src={img['more-cash.webp']} alt="more cash" />    
                            ): isShowCoin ? (
                              <img src={img['coin.webp']} alt="coin" />    
                            ): isShowMoreCoin ? (
                              <img src={img['more-coin.webp']} alt="more coin" />    
                            ): isShowFreeSpin ? (
                              <img className="spin" src={img['spin.webp']} alt="spin" />    
                            ): isShowMoreFreeSpin ? (
                              <img className="spin" src={img['more-spin.webp']} alt="more spin" />    
                            ): <img src={img['coin.webp']} alt="coin" /> }

                            <div className='check-in-label'>                          
                              {isShowCash || isShowMoreCash ? (
                                // Cash
                                <>
                                  <p className="number">+MYR{creditValue}</p>
                                  {extraCreditValue > 0 && <span>{t('check_in.extra')} +{extraCreditValue}</span>}                                                        
                                </>
                              ): isShowCoin || isShowMoreCoin ? (
                                // Coins
                                <>
                                  <p className="number">+{coinValue} {t('check_in.coins')}</p>
                                  {extraCoinValue > 0 && <span>{t('check_in.extra')} +{extraCoinValue}</span>}                                                        
                                </>
                              ): isShowFreeSpin || isShowMoreFreeSpin ? (
                                // Free Spin
                                <>
                                  <p className="number">x{spinValue} {t('check_in.free-spins')}</p>
                                  {extraSpinValue > 0 && <span>{t('check_in.extra')} x{extraSpinValue}</span>}                                                        
                                </>
                              ): 
                                <p className="number">+{coinValue} {t('check_in.coins')}</p> // default to coin
                              }                                                                                                
                            </div>            
                          </div>                                            
                        </div>

                        {/* recheck-in tag */}
                        {isShowReCheckInAvailableTag && <span className="re-check-in-tag">{t('check_in.recheck-in-available')}</span>}                                                
                        
                        <div className='claim-icon'>
                          <>
                            {this.state.isAuthenticated && (!this.props?.isCheckInPage || isMatchVip) && (
                              <>
                                {
                                  showTickOrCross === 'TICK' ? <img src={icon['tick.svg']} alt='claimed'/> 
                                  : <span></span>
                                }
                              </>                            
                            )}
                          </>
                        </div>               
                      </div>                    
                    </div>
                )})
              }
            </div>                          
          </div> 

          <div className={`bottom ${!isMatchVip && 'inactive' }`}>
            <span className="more-details">
              {this.props.isCheckInPage ? t('check_in.rewards-check-in') : this.state.isAuthenticated ? 
                (
                  <>
                    {t('check_in.play-get-rewards')}
                    <a href="/check-in">{t('promos.more-details')}</a>                
                  </>
                )
                :
                (
                  <>
                    {t('check_in.play-get-rewards')}
                    <a href="/login">{t('register.login-now')}</a>
                  </>
                )
              }
            </span>    

            {/* Only appears in home page (buttons Done or Check-in Now and Re-Check-In) */}
            <div className="btn-popup">
              <button className="btn more-btn-blue" 
                disabled={!isEnableCheckInButton} 
                onClick={() => this.handleCheckIn('check-in')}>
                {this.props.memberProgress?.days?.[day]?.isCheckedIn ? t('message.done') : t('check_in.check-in-now')}              
              </button>
              <button 
                className={`btn more-btn-blue white ${isEnableReCheckInButton && 'gradient-border'}`} 
                disabled={!isEnableReCheckInButton} 
                onClick={() => this.handleCheckIn('recheck-in')} 
              >
                {t('check_in.re-check-in')}
              </button>
              {this.state.isAuthenticated && <span>{this.props.memberProgress.totalRemainingReCheckIn} / 2</span>}              
            </div>

            {/* Countdown timer to next rewards */}
            <div className='next-rewards'>
              <p>{t('check_in.next-rewards')}</p>
              <span>
                {this.formatTimer(this.state.timeLeft.hours)}:
                {this.formatTimer(this.state.timeLeft.minutes)}:
                {this.formatTimer(this.state.timeLeft.seconds)}
              </span>
            </div>   

            {/* Only appears in route /check-in (buttons Check-in and Re-Check-In) */}
            <div className="d-flex align-items-center gap-3">
              <button className="btn enter-btn-blue" disabled={!isEnableCheckInButton} onClick={() => this.handleCheckIn('check-in')}>
                {this.props.memberProgress?.days?.[day]?.isCheckedIn ? t('message.done') : t('check_in.check-in')}              
              </button>
              <button 
                className={`btn enter-btn-blue white ${isEnableReCheckInButton && 'gradient-border'}`} 
                disabled={!isEnableReCheckInButton}
                onClick={() => this.handleCheckIn('recheck-in')}
              >
                {t('check_in.re-check-in')}
              </button>
              {this.props.isCheckInPage && <span style={{ color: "#E7C292"}}>{this.props.memberProgress.totalRemainingReCheckIn} / 2</span>}
            </div>             

            {/* Simulator for staging only */}
            {
              process.env.REACT_APP_ENV === "staging" && (
                <>
                  <button 
                    className="btn more-btn-blue"
                    onClick={() => this.setState({ showSimulator: !this.state.showSimulator })}
                  >
                    Simulator
                  </button>
                  {this.state.showSimulator && (
                    <div
                      className="d-flex flex-column gap-2 text-center"
                      style={{
                        border: "2px dashed #e57373",
                        borderRadius: 8,
                        padding: 16,
                        margin: "16px 0"
                      }}
                    >
                      <span>Simulator</span>
                  <div className="d-flex flex-column gap-2">                   
                    {/* Row 1: 2 checkboxes */}
                    <div className="d-flex justify-content-center gap-3 mb-2">
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="checkInBox"
                          checked={this.state.simulator.operation === 'check-in'}
                          onChange={() => this.setState({ simulator: { ...this.state.simulator, operation: 'check-in' } })}
                        />
                        <label className="form-check-label" htmlFor="checkInBox">
                          Check In
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="reCheckInBox"
                          checked={this.state.simulator.operation === 'recheck-in'}
                          onChange={() => this.setState({ simulator: { ...this.state.simulator, operation: 'recheck-in' } })}
                        />
                        <label className="form-check-label" htmlFor="reCheckInBox">
                          Re-check In
                        </label>
                      </div>
                    </div>
                    {/* Row 2: Used Credit */}
                    <div className="d-flex justify-content-center">
                      <div className="d-flex align-items-center gap-2">
                        <span>Used Credit</span>
                        <input
                        type="number"
                        className="form-control text-center"
                        style={{ maxWidth: 190 }}
                        value={this.state.simulator.usedCredit}
                        onChange={(e) => this.setState({ simulator: { ...this.state.simulator, usedCredit: e.target.value } })}
                      />
                      </div>
                    </div>
                    {/* Row 3: Datepicker */}
                    <div className="d-flex justify-content-center">
                      <input
                        type="date"
                        className="form-control text-center"
                        style={{ maxWidth: 190 }}
                        value={this.state.simulator.checkInDate}
                        onChange={(e) => {
                          this.setState({
                            simulator: {
                              ...this.state.simulator,
                              checkInDate: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>
                     {/* Row 4: 7 horizontal buttons labeled 1-7 */}
                     <div className="d-flex justify-content-center gap-2 mb-2">
                      {[0,1,2,3,4,5,6].map((n) => (
                        <button
                          key={n}
                          type="button"
                          className="btn btn-outline-primary"
                          style={{ minWidth: 32, padding: '0 8px' }}
                          onClick={() => {

                            this.setState({
                              simulator: { ...this.state.simulator, day: n },
                            }, () => {
                              this.handleSimulateCheckIn();
                            });

                          }}
                        >
                          {n + 1}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex justify-content-center">
                    <button className="btn btn-danger" onClick={() => this.props.clearProgress()}>
                      Revert All Progress
                    </button>
                  </div>
                </div>
                  )}
                </>
              )
            }
          </div>        
        </div>
      </div>
    );
  }
}

const mapStateToProps = (reduxState) => {
  return {
    memberProgress: reduxState.dailyCheckIn?.memberProgress?.data?.data || {},
    resultCheckIn: reduxState.dailyCheckIn?.checkIn?.data || {},
    vipLevelRequirementAndReward: reduxState.dailyCheckIn?.vipLevelRequirementAndReward?.data || {},
    currentUser: reduxState.currentUser,
  };
};

const mapDispatchToProps = {
  getMemberProgress,
  checkIn,
  getVipLevelRequirementAndReward,
  clearProgress,
  simulateCheckIn
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(MemberProgress));
